module.exports = __webpack_public_path__ + "img/goal.3aca7e51.png";